// src/views/assembleias/VotacaoOnline.jsx
// Página pública acessada via link: /votar?token=xxx
import React, { useState, useEffect } from "react";
import assembleiaService from "../../services/assembleiaService";

const fmtD = d => { try{ const s=(d||"").split("T")[0].split(" ")[0]; return new Date(s+"T12:00:00").toLocaleDateString("pt-BR",{weekday:"long",day:"2-digit",month:"long",year:"numeric"}); }catch{ return d||"—"; } };
const fmtH = h => h?h.substring(0,5):"";

export default function VotacaoOnline() {
  const token = new URLSearchParams(window.location.search).get("token");

  const [dados,      setDados]      = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [erro,       setErro]       = useState("");
  const [erroVoto,   setErroVoto]   = useState("");
  const [votos,      setVotos]      = useState({});  // { idPauta: voto }
  const [enviando,   setEnviando]   = useState(false);
  const [sucesso,    setSucesso]    = useState(false);
  const [msgSucesso, setMsgSucesso] = useState("");
  // Modal de confirmação para alteração de votos
  const [confirmAlterar, setConfirmAlterar] = useState(false);

  useEffect(() => {
    if (!token) { setErro("Link inválido — token não encontrado."); setLoading(false); return; }
    assembleiaService.buscarPorToken(token)
      .then(r => {
        if (!r.success) { setErro(r.message||"Link inválido."); return; }
        setDados(r.data);
        // Pré-preenche votos já registrados
        if (r.data.jaVotou) {
          const prev = {};
          Object.entries(r.data.jaVotou).forEach(([k,v])=>{ prev[k]=v; });
          setVotos(prev);
        }
      })
      .catch(() => setErro("Erro ao carregar a votação."))
      .finally(() => setLoading(false));
  }, [token]);

  const handleConfirmarCiencia = async () => {
    setEnviando(true);
    try {
      // Envia array vazio de votos - server registra presença e marca token como usado
      const r = await assembleiaService.votarOnline({ token, votos: [] });
      if (r.success || r.message) {
        setSucesso(true);
        setMsgSucesso("✅ Ciência confirmada! Sua presença foi registrada nesta assembleia.");
      } else {
        setErroVoto(r.message || "Erro ao confirmar ciência.");
      }
    } catch(e) { setErroVoto(e.message || "Erro ao confirmar ciência."); }
    setEnviando(false);
  };

  const enviarVotos = async () => {
    setEnviando(true);
    setErroVoto("");
    try {
      const payload = { token, votos: Object.entries(votos).map(([idPauta,voto])=>({idPauta:Number(idPauta),voto})) };
      const r = await assembleiaService.votarOnline(payload);
      if (r.success) { setSucesso(true); setMsgSucesso(r.message); }
      else setErroVoto(r.message||"Erro ao registrar votos.");
    } catch(e) { setErroVoto(e.message||"Erro ao enviar votos."); }
    setEnviando(false);
    setConfirmAlterar(false);
  };

  const handleVotar = async () => {
    setErroVoto("");
    const pautasVotaveis = (dados.pautas||[]).filter(p=>p.tpPauta!=="Informativo");
    const naoVotadas = pautasVotaveis.filter(p=>!votos[p.id]);
    if (naoVotadas.length > 0) {
      setErroVoto(`Vote em todas as pautas antes de confirmar. Faltam: ${naoVotadas.map(p=>p.titulo).join(", ")}`);
      return;
    }
    // Se já votou em alguma pauta, abre modal de confirmação de alteração
    const jaVotouEmAlguma = Object.keys(dados.jaVotou||{}).length > 0;
    if (jaVotouEmAlguma) {
      setConfirmAlterar(true);
      return;
    }
    await enviarVotos();
  };

  if (loading) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#f0f4f8"}}>
      <div style={{textAlign:"center"}}><span className="spinner-border text-primary" style={{width:48,height:48}}/><p style={{marginTop:12,color:"#64748b"}}>Carregando...</p></div>
    </div>
  );

  if (erro) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#f0f4f8",padding:16}}>
      <div style={{background:"var(--bg-surface)",borderRadius:16,padding:32,maxWidth:440,textAlign:"center",boxShadow:"0 4px 24px rgba(0,0,0,.1)"}}>
        <i className="bi bi-x-circle-fill" style={{fontSize:56,color:"#991B1B",display:"block",marginBottom:12}}/>
        <h3 style={{color:"#991B1B",marginBottom:8}}>Link inválido</h3>
        <p style={{color:"#64748b",fontSize:14}}>{erro}</p>
      </div>
    </div>
  );

  if (sucesso) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#f0f4f8",padding:16}}>
      <div style={{background:"var(--bg-surface)",borderRadius:16,padding:32,maxWidth:440,textAlign:"center",boxShadow:"0 4px 24px rgba(0,0,0,.1)"}}>
        <i className="bi bi-check-circle-fill" style={{fontSize:64,color:"#166534",display:"block",marginBottom:16}}/>
        <h2 style={{color:"#166534",marginBottom:8}}>Voto Registrado!</h2>
        <p style={{color:"#64748b",fontSize:14}}>{msgSucesso}</p>
        <p style={{color:"#94a3b8",fontSize:12,marginTop:12}}>Obrigado pela sua participação.</p>
        <div style={{marginTop:20,padding:"12px 16px",background:"var(--bg-success-soft)",borderRadius:8,fontSize:13,color:"#166534"}}>
          <strong>Resumo dos seus votos:</strong>
          {Object.entries(votos).map(([idPauta,voto])=>{
            const p = dados.pautas.find(pp=>String(pp.id)===String(idPauta));
            return p ? <div key={idPauta} style={{marginTop:4}}>• {p.titulo}: <strong>{voto}</strong></div> : null;
          })}
        </div>
      </div>
    </div>
  );

  if (!dados) return null;

  const pautasVotaveis    = (dados.pautas||[]).filter(p=>p.tpPauta!=="Informativo");
  const apenasInformativo = pautasVotaveis.length === 0 && (dados.pautas||[]).length > 0;
  // Backend agora retorna podeAlterar=true enquanto status ∈ (Convocada, EmAndamento).
  // Mesmo se o token já foi usado uma vez, o condômino pode revisar/alterar voto.
  const podeAlterar      = !!dados.podeAlterar;
  const votacaoAberta    = !["Encerrada","Cancelada"].includes(dados.status) && !dados.expirado && podeAlterar;
  const cienciaAberta    = apenasInformativo && !dados.tokenUsado && !dados.expirado && !["Encerrada","Cancelada"].includes(dados.status);
  const jaVotouTudo      = pautasVotaveis.every(p=>dados.jaVotou?.[p.id]);
  const jaVotouAlgo      = Object.keys(dados.jaVotou||{}).length > 0;

  return (
    <div style={{minHeight:"100vh",background:"#f0f4f8",padding:"16px 12px"}}>
      <div style={{maxWidth:580,margin:"0 auto"}}>

        {/* Header */}
        <div style={{background:"#1B3A6B",color:"#fff",borderRadius:"12px 12px 0 0",padding:"20px 24px"}}>
          <div style={{fontSize:11,opacity:.7,marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>
            🏢 {dados.condominio}
          </div>
          <h2 style={{margin:"0 0 6px",fontSize:20,fontWeight:700}}>{dados.titulo}</h2>
          <div style={{fontSize:13,opacity:.8}}>
            📅 {fmtD(dados.dtAssembleia)} às {fmtH(dados.hrInicio)}
            {dados.local && ` • 📍 ${dados.local}`}
          </div>
          <div style={{marginTop:8,fontSize:12,opacity:.7}}>
            Unidade: <strong>{dados.unidade}</strong>
          </div>
        </div>

        {/* Status banner */}
        {dados.tokenUsado && !sucesso && !podeAlterar && (
          <div style={{background:"var(--bg-success-soft)",padding:"10px 16px",fontSize:13,color:"#166534",borderBottom:"1px solid #BBF7D0",display:"flex",alignItems:"center",gap:8}}>
            <i className="bi bi-check-circle-fill"/>
            {apenasInformativo
              ? "✅ Você já confirmou ciência desta assembleia."
              : "✅ Você já registrou seus votos nesta assembleia."}
          </div>
        )}
        {dados.tokenUsado && !sucesso && podeAlterar && jaVotouAlgo && (
          <div style={{background:"var(--bg-highlight)",padding:"10px 16px",fontSize:13,color:"#1D4ED8",borderBottom:"1px solid #BFDBFE",display:"flex",alignItems:"center",gap:8}}>
            <i className="bi bi-arrow-clockwise"/>
            <span>Você já votou. <strong>Pode alterar seus votos enquanto a votação estiver aberta.</strong></span>
          </div>
        )}
        {dados.expirado && (
          <div style={{background:"var(--bg-danger-soft)",padding:"10px 16px",fontSize:13,color:"#991B1B",borderBottom:"1px solid #FECACA"}}>
            ⏰ O prazo de votação expirou.
          </div>
        )}
        {!["Convocada","EmAndamento"].includes(dados.status) && (
          <div style={{background:"var(--bg-page)",padding:"10px 16px",fontSize:13,color:"var(--gray-600)",borderBottom:"1px solid var(--border-color)"}}>
            ℹ️ A votação {dados.status==="Encerrada"?"foi encerrada":"não está aberta no momento"}.
          </div>
        )}

        {/* Pautas */}
        <div style={{background:"var(--bg-surface)",borderRadius:"0 0 12px 12px",padding:20,boxShadow:"0 4px 20px rgba(0,0,0,.08)"}}>
          {(dados.pautas||[]).length === 0 ? (
            <p style={{textAlign:"center",color:"#94a3b8",padding:"24px 0"}}>Nenhuma pauta cadastrada.</p>
          ) : (
            (dados.pautas||[]).map((p,i)=>{
              const jáVotou = dados.jaVotou?.[p.id] || votos[p.id];
              return (
                <div key={p.id} style={{marginBottom:20,padding:"16px",borderRadius:10,
                  border:`2px solid ${votos[p.id]?"var(--bs-success, #198754)":"#e2e8f0"}`,
                  background:votos[p.id]?"#F0FDF4":"#fff"}}>
                  <div style={{fontWeight:700,fontSize:14,color:"#1e293b",marginBottom:4}}>
                    {i+1}. {p.titulo}
                  </div>
                  {p.descricao && <p style={{fontSize:13,color:"#64748b",margin:"0 0 10px"}}>{p.descricao}</p>}

                  {p.tpPauta==="Informativo" ? (
                    <div style={{fontSize:12,color:"#94a3b8",fontStyle:"italic"}}>Item informativo — sem votação necessária.</div>
                  ) : (
                    <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                      {["Aprovado","Reprovado","Abstencao"].map(op=>{
                        const votoAtual = votos[p.id] || dados.jaVotou?.[p.id];
                        const selected  = votoAtual === op;
                        const colors    = {Aprovado:["#166534","#DCFCE7","#22C55E"],Reprovado:["#991B1B","#FEE2E2","#EF4444"],Abstencao:["#475569","#F1F5F9","#94A3B8"]};
                        const [tc,bg,bc] = colors[op];
                        const podeClicar = votacaoAberta; // permite alterar voto até a assembleia encerrar
                        return (
                          <button key={op} disabled={!podeClicar}
                            onClick={()=>setVotos(prev=>({...prev,[p.id]:op}))}
                            style={{flex:1,minWidth:90,padding:"10px 8px",borderRadius:8,cursor:podeClicar?"pointer":"not-allowed",
                              border:`2px solid ${selected?bc:"#e2e8f0"}`,
                              background:selected?bg:"#fff",
                              color:selected?tc:"#64748b",
                              fontWeight:selected?700:400,fontSize:13,
                              transition:"all .15s",
                              opacity: podeClicar ? 1 : .6}}>
                            {op==="Aprovado"?"✅ Aprovar":op==="Reprovado"?"❌ Reprovar":"⚪ Abstiver"}
                          </button>
                        );
                      })}
                    </div>
                  )}
                  {jáVotou && votos[p.id] && votos[p.id] !== dados.jaVotou?.[p.id] && (
                    <div style={{marginTop:6,fontSize:11,color:"#1D4ED8"}}>
                      <i className="bi bi-info-circle me-1"/>
                      Alterando voto: <s style={{opacity:.7}}>{dados.jaVotou[p.id]}</s> → <strong>{votos[p.id]}</strong>
                    </div>
                  )}
                </div>
              );
            })
          )}

          {/* Botão confirmar ciência (apenas informativo) */}
          {cienciaAberta && (
            <div style={{marginTop:16}}>
              <div style={{background:"var(--bg-highlight)",borderRadius:8,padding:"12px 14px",
                marginBottom:12,fontSize:13,color:"#1D4ED8",display:"flex",gap:8}}>
                <i className="bi bi-info-circle-fill" style={{flexShrink:0,marginTop:1}}/>
                <span>Esta assembleia possui apenas itens informativos. Clique em confirmar para registrar sua presença e ciência das pautas.</span>
              </div>
              {erroVoto && (
                <div style={{background:"var(--bg-danger-soft)",color:"#991B1B",borderRadius:8,padding:"10px 14px",
                  marginBottom:12,fontSize:13,display:"flex",gap:8}}>
                  <i className="bi bi-exclamation-circle-fill" style={{flexShrink:0}}/>
                  <span>{erroVoto}</span>
                </div>
              )}
              <button className="btn btn-success w-100" onClick={handleConfirmarCiencia} disabled={enviando}
                style={{padding:"12px 0",fontSize:15,fontWeight:700}}>
                {enviando
                  ? <><span className="spinner-border spinner-border-sm me-2"/>Registrando...</>
                  : <><i className="bi bi-check-circle-fill me-2"/>Confirmar Ciência</>}
              </button>
            </div>
          )}

          {/* Botão confirmar voto — sempre que houver pautas votáveis e votação aberta */}
          {votacaoAberta && pautasVotaveis.length > 0 && (
            <>
            {erroVoto && (
              <div style={{background:"var(--bg-danger-soft)",color:"#991B1B",borderRadius:8,padding:"10px 14px",
                marginBottom:12,fontSize:13,display:"flex",gap:8,alignItems:"flex-start"}}>
                <i className="bi bi-exclamation-circle-fill" style={{flexShrink:0,marginTop:2}}/>
                <span>{erroVoto}</span>
              </div>
            )}
            {jaVotouTudo && !Object.keys(votos).length && (
              <div style={{background:"var(--bg-success-soft)",color:"#166534",borderRadius:8,padding:"10px 14px",
                marginBottom:12,fontSize:13,textAlign:"center"}}>
                <i className="bi bi-check-circle-fill me-2"/>
                Seus votos foram registrados. Você pode alterá-los enquanto a votação estiver aberta.
              </div>
            )}
            <button className="btn btn-primary w-100 mt-2" onClick={handleVotar}
              disabled={enviando || Object.keys(votos).length === 0}
              style={{padding:"12px 0",fontSize:15,fontWeight:700,opacity:Object.keys(votos).length===0?.6:1}}>
              {enviando
                ? <><span className="spinner-border spinner-border-sm me-2"/>Registrando votos...</>
                : jaVotouAlgo
                  ? <><i className="bi bi-arrow-repeat me-2"/>Atualizar Meus Votos</>
                  : <><i className="bi bi-check-circle-fill me-2"/>Confirmar Meus Votos</>}
            </button>
            </>
          )}

          {!votacaoAberta && jaVotouTudo && !sucesso && (
            <div style={{textAlign:"center",padding:"16px",background:"var(--bg-success-soft)",borderRadius:8,marginTop:8,color:"#166534",fontSize:13}}>
              <i className="bi bi-check-circle-fill me-2"/>Seus votos já foram registrados. Obrigado!
            </div>
          )}
        </div>

        <div style={{textAlign:"center",marginTop:12,fontSize:11,color:"#94a3b8"}}>
          Powered by Horizon eCondo — Este link é pessoal e intransferível
        </div>
      </div>

      {/* Modal de confirmação de alteração de voto */}
      {confirmAlterar && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:9999,
          display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
          onClick={()=>!enviando && setConfirmAlterar(false)}>
          <div style={{background:"var(--bg-surface)",borderRadius:12,padding:24,maxWidth:420,width:"100%",boxShadow:"0 10px 40px rgba(0,0,0,.2)"}}
            onClick={e=>e.stopPropagation()}>
            <h3 style={{margin:"0 0 8px",fontSize:17,color:"#1B3A6B"}}>
              <i className="bi bi-arrow-repeat me-2" style={{color:"#F59E0B"}}/>
              Alterar votos?
            </h3>
            <p style={{margin:"0 0 6px",fontSize:14,color:"var(--gray-600)"}}>
              Você já registrou votos anteriormente nesta assembleia.
            </p>
            <p style={{margin:"0 0 16px",fontSize:13,color:"var(--gray-500)"}}>
              Seus votos atuais serão <strong>substituídos</strong> pelos novos. Deseja continuar?
            </p>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-outline-secondary" onClick={()=>setConfirmAlterar(false)} disabled={enviando}>
                Cancelar
              </button>
              <button className="btn btn-primary" onClick={enviarVotos} disabled={enviando}>
                {enviando
                  ? <><span className="spinner-border spinner-border-sm me-2"/>Atualizando...</>
                  : <><i className="bi bi-check-circle me-1"/>Confirmar Alteração</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
